const constants = {
  columnWidth: {
    CUSTOMER_NAME: 250,
    CUSTOMER_ACC_NUMBER: 100,
    CUSTOMER_ALIASES: 100,
    CUSTOMER_ADDRESS: 250,
    CUSTOMER_CITY: 120,
    CUSTOMER_STATE: 90,
    CUSTOMER_ZIP: 100,
    GROUPED_CUSTOMERS : 250,
  },
};

export default constants;
